import React from 'react';
import moment from 'moment';
import { useLocalStorage } from 'utils/useLocalStorage';

const FleetFiltersContext = React.createContext();

const today = moment();

const _defaultFilters = {
  date: { from: today.format('YYYY-MM-DD'), to: today.format('YYYY-MM-DD') },
  business: undefined,
};

function FleetFiltersContextProvider({ defaultFilters = {}, children }) {
  const [filters, setFilters] = useLocalStorage('fleet/filters', defaultFilters);
  const value = { filters, setFilters };

  return <FleetFiltersContext.Provider value={value}>{children}</FleetFiltersContext.Provider>;
}

export default FleetFiltersContext;
export { _defaultFilters as defaultFilters, FleetFiltersContextProvider };
